export default {"src":"/_next/static/media/homeins.db8bb8b6.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};